import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Vi er kede af, at artiklen ikke var nyttig. Vil du fortælle os, hvad der var galt?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Den information, jeg leder efter, mangler',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Der er faktuelle fejl',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Nogle punkter er uklare',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Giv os nogle detaljer, så vi kan forbedre denne artikel.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Send'
    }
  }
};